<template>
  <div class="header-notification">
    <a href="http://">{{ message }} </a>
  </div>
</template>

<script>
import homeContent from '@/assets/home-content.json';

export default {
  name: "HeaderNotification",
  props: {
    // Header passes this down from its own content block; the default keeps
    // the bar intact wherever Header is rendered without one.
    message: {
      type: String,
      default: () => homeContent.HomeHeader.notification
    }
  }
};
</script>

<style>
</style>